// extracted by mini-css-extract-plugin
module.exports = {"chip":"SaveAttributeConfiguration_chip__2oRK7"};